<template>
    <div class="text-5xl text-graytitle mb-6">Сброс пароля</div>
    <form class="max-w-md" @submit.prevent="reset">
        <b-input class="mb-10" v-model="email" @input="validation">Введите e-mail</b-input>
        <b-button :disabled="isDisabled" class="mb-4" :class="{'opacity-50': isDisabled}">Сбросить пароль</b-button>
        <div class="text-center text-darkblue text-lg">
            <router-link to="/login">Вернуться к экрану авторизации</router-link>
        </div>
    </form>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAuthStore } from '@/stores/authStore'

const email = ref("")
const isDisabled = ref(true)

const store = useAuthStore()

async function reset() {
    await store.passwordReset({login: email.value})
}

function validation() {
    const re = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/
    if(re.test(email.value)) {
        isDisabled.value = false
    }
    else {
        isDisabled.value = true
    }
}

</script>
